module.exports = __webpack_public_path__ + "img/logo.a6fc5344.png";